// src/components/documents/ui/DocumentFormUI.tsx
import { cn } from "@/lib/utils"

export const documentFormTheme = {
  mainContainer: "p-8 space-y-8",

  label: "text-purple-300 text-lg",

  input: "bg-purple-950/60 border-purple-300/40 text-white mt-1 focus:border-purple-400 focus:ring-purple-400 rounded-3xl text-lg",

  textarea: "bg-purple-950/60 border-purple-300/40 text-white min-h-[140px] mt-1 focus:border-purple-400 focus:ring-purple-400 rounded-3xl text-lg",

  selectTrigger: cn(
    "bg-purple-950/70 backdrop-blur-2xl border border-purple-300/40 text-white mt-1 text-lg",
    "hover:border-purple-400 focus:border-purple-400 focus:ring-purple-400 rounded-3xl px-5 py-3"
  ),

  selectContent: "bg-purple-950/95 backdrop-blur-2xl border border-purple-300/40 rounded-3xl shadow-2xl py-2 z-50",

  selectItem: "px-5 py-3.5 text-lg text-purple-200 hover:bg-purple-900/60 hover:text-white cursor-pointer rounded-2xl mx-1 transition-colors",

  fileUploadArea: "cursor-pointer bg-purple-950/60 hover:bg-purple-950/80 border border-purple-300/40 text-purple-200 px-8 py-4 rounded-3xl transition-all flex items-center gap-3 text-lg",

  footer: "flex justify-end gap-4 pt-8 border-t border-purple-300/30",

  cancelButton: cn(
    "border border-purple-300/40 text-purple-200 hover:bg-purple-900/60 hover:border-purple-300/60",
    "bg-purple-950/60 backdrop-blur-xl rounded-3xl transition-all text-lg px-8 py-6"
  ),

  submitButton: "bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 min-w-[180px] rounded-3xl text-lg px-8 py-6",

  errorText: "text-red-400 text-base mt-1",
} as const